import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  ActiveInactiveSetting,
  createSetting,
  deleteSetting,
  getAllActiveSetting,
  getAllSetting,
  getSettingByID,
  updateSetting,
} from "./services/setting.services";

export interface ISettingState {
  loading: boolean;
  formloading: boolean;
  error: string;
  SettingID: number | null;
  SettingList: ISetting[];
  SettingDetail: ISettingDetails;
}

export interface ISettingDetails {
  ID?: number | null;

  SettingKey: string;
  SettingType: string;
  SettingValue: string;

  IsActive: number | boolean;
}
export interface ISetting {
  SettingKey: string;
  SettingType: string;
  SettingValue: string;
  IsActive: number | boolean;
}

const initialState: ISettingState = {
  loading: false,
  formloading: false,
  error: "",
  SettingID: null,
  SettingList: [],
  SettingDetail: {
    SettingKey: "",
    SettingType: "",
    SettingValue: "",
    IsActive: 1,
  },
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    clearSettingDetails: (state) => {
      state.SettingDetail = initialState.SettingDetail;
    },
    setSettingID: (state, action) => {
      state.SettingID = action.payload;
    },
    clearSettingID: (state) => {
      state.SettingID = initialState.SettingID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllSetting.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllSetting.fulfilled,
      (state, action: PayloadAction<ISetting[]>) => {
        state.loading = false;
        state.SettingList = action.payload || [];
      }
    );
    builder.addCase(getAllSetting.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SettingList = [];
    });
    builder.addCase(createSetting.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(createSetting.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(createSetting.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateSetting.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(updateSetting.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(updateSetting.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteSetting.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteSetting.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteSetting.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getSettingByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getSettingByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.SettingDetail = action.payload;
    });
    builder.addCase(getSettingByID.rejected, (state, action) => {
      state.loading = false;
      state.SettingDetail = initialState.SettingDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveSetting.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveSetting.fulfilled,
      (state, action: PayloadAction<ISetting[]>) => {
        state.loading = false;
        state.SettingList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveSetting.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SettingList = [];
    });
    builder.addCase(ActiveInactiveSetting.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveSetting.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveSetting.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearSettingDetails, clearSettingID, setSettingID } =
  settingSlice.actions;
export default settingSlice.reducer;
